import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { RogSkuDetail } from '../../../api/models/rog';

@Component({
  selector: 'app-rog-lines-table',
  templateUrl: './rog-lines-table.component.html',
  styleUrls: ['./rog-lines-table.component.scss']
})
export class RogLinesTableComponent implements OnInit {

  @Input() lines: RogSkuDetail[] = [];

  // @Output() linesSelectionUpdate = new EventEmitter<OrderItem[]>();
  @Output() linesSelectionUpdate = new EventEmitter<RogSkuDetail[]>();

  selectedAll = false;

  uncheckAll = false;

  showNoOrdersMessage = false;
  infoMsg = ['Shipping and tracking details are not available!! Please wait until the order is shipped.'];
  linesSelected: RogSkuDetail[] = [];

  constructor() { 
    //Empty constructor
  }

  ngOnInit() {
    if(this.lines!=null){
      this.showNoOrdersMessage = false;
    }else{
      this.showNoOrdersMessage = true;
    }
  }

  selectLine(rogSkuLineSelected:RogSkuDetail) {
  if (this.linesSelected.find(lineSelected => lineSelected.id === rogSkuLineSelected.id)) {
      this.linesSelected = this.linesSelected.filter(lineSelected => lineSelected.id !== rogSkuLineSelected.id);
    } else {
      this.linesSelected.push(rogSkuLineSelected);
    }
    this.linesSelectionUpdate.emit(this.linesSelected);
  }

  allAreSelected() {
    return this.lines.length === this.linesSelected.length;
  }

  atLeastOneSelected() {
    return (this.linesSelected.length && !this.allAreSelected());
  }

  isSelected(id: string) {
    return this.linesSelected.find(line => line.id === id);
  }

  setStatus(linesUpdated: RogSkuDetail[], status: string) {
    this.lines.forEach(line => {
      if (linesUpdated.find(lineUpd => line.id === lineUpd.id)) {
         line.status = status;
      }
    });
    this.selectAll();
  }

  selectAll() {
    this.selectedAll = !this.selectedAll;
    if (this.linesSelected.length) {
      this.linesSelected = [];
    } else {
       this.lines.forEach(line => this.linesSelected.push(line));
    }
    this.linesSelectionUpdate.emit(this.linesSelected);
  }

  getpodStatus(podStatus: String) {
    if (podStatus === '01') {
      return "Delivered";
    } else if (podStatus === '02') {
      return "Return UnDelivered";
    } else {
      return "N/A";
    }
  }

  cleanString(input: string): string {
    let normalizedInput = input.normalize("NFKC");
    let cleaned = normalizedInput.replace(/[^\x20-\x7E\u200B\u00A0]/g, "");
    return cleaned;
  }
   
  navigateToCarrierWebsite(rogLine: RogSkuDetail): void {
    let carrierWeb = this.cleanString(rogLine.carrierWebsite);
    const tracknumberRegex = /replacetracknumber/i;
    if (tracknumberRegex.test(carrierWeb)) {
      let url = carrierWeb.replace('replacetracknumber', rogLine.trackingID.trim());
      window.open(url, "_blank");
    } else {
      window.open(carrierWeb, "_blank");
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/rog-confirmation-dialog/rog-lines-table/rog-lines-table.component.ts